import React from "react";

export default function Problem() {
  return (
    <section id="il-problema" className="py-24 md:py-32 bg-cream border-y border-chocolate/5 font-sans">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center space-y-16">
        
        {/* Pain Point Section */}
        <div className="space-y-6 max-w-2xl mx-auto">
          <span className="text-xs font-medium uppercase tracking-[0.2em] text-bordeaux">
            LA DOMANDA CHE TI PONI SPESSO
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-chocolate font-editorial leading-tight">
            Perché continui a ripetere <br className="hidden sm:inline" />
            <span className="italic text-champagne-dark">gli stessi schemi emotivi?</span>
          </h2>
          <p className="text-base sm:text-lg leading-relaxed text-chocolate/80 font-light">
            {"Hai letto libri, ascoltato podcast, guardato video e forse hai intrapreso anche percorsi di terapia. Eppure, ti ritrovi sempre nello stesso punto: svuotata, in attesa di un messaggio, preoccupata di non essere abbastanza scelta, intrappolata in relazioni che consumano la tua energia vitale."}
          </p>
        </div>

        {/* The True Mechanism Block */}
        <div className="border border-champagne/30 bg-bordeaux p-8 md:p-12 text-left grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-7 space-y-4">
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-champagne">
              IL VERO MECCANISMO
            </span>
            <h3 className="text-xl sm:text-2xl font-normal tracking-tight text-ivory font-editorial">
              {"Il problema non è l'uomo. È aver perso sé stesse."}
            </h3>
            <p className="text-sm sm:text-base leading-relaxed text-ivory font-light">
              {"Quando ti disconnetti dalla tua identità, dai tuoi bisogni e dai tuoi confini, inizi ad amare da uno stato di paura, dipendenza e insicurezza. Credi che cambiando lui o rincorrendolo potrai salvarti. Ma la verità è che non puoi ricevere dall'esterno la sicurezza che hai negato a te stessa."}
            </p>
          </div>
          <div className="md:col-span-5 border-t md:border-t-0 md:border-l border-champagne/30 pt-6 md:pt-0 md:pl-8 flex flex-col justify-center">
            <p className="font-editorial text-lg italic text-champagne leading-relaxed">
              {"\"Non cambiamo l’altra persona. Cambiamo la posizione da cui scegliamo di amare.\""}
            </p>
            <span className="text-xs tracking-wider uppercase text-champagne mt-3 font-semibold">
              — Filosofia Feminine Return™
            </span>
          </div>
        </div>

      </div>
    </section>
  );
}
